import {Controller} from "@hotwired/stimulus";
import _ from "lodash"

export default class extends Controller {
  static values = {
    url: {type: String, default: undefined}
  }
  static outlets = ["grid"]

  connect() {
    let outlets = this.gridOutlets
    let url = this.urlValue
    fetch(url).then(function (r) {
      let ds = new DecompressionStream('gzip');
      let decompressed_stream = r.body.pipeThrough(ds);
      new Response(decompressed_stream).text().then(function (d) {
        let data = JSON.parse(d)
        if (Array.isArray(data)) {
          let headers = _.map(_.keys(data[0]), function (i) {
            return {
              headerName: i,
              field: i,
              sortable: true,
              resizable: true,
              pinned: false,
              filter: true,
            }
          })
          outlets[0].insertRowsToGrid(data, headers)
        } else {
          let headers = _.map(data['meta'], function (i) {
            return {
              headerName: i.name,
              field: i.name,
              sortable: true,
              resizable: true,
              pinned: false,
              filter: true,
            }
          })
          outlets[0].insertRowsToGrid(data['data'], headers)
        }
      });

    })

  }
}
